export default "__VITE_ASSET__Bcyy3sr7__"